// src/pages/LoginAdmin.jsx
// Acceso exclusivo para administradores (Grp_IdGrp = 1).
// Bypasea la pantalla de mantenimiento — siempre muestra el formulario.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../services/api';
import CustomSelect from '../components/CustomSelect';

const COLOR = '#2a9d8f';

export default function LoginAdmin() {
  const { loginWithData } = useAuth();
  const navigate = useNavigate();

  const [form, setForm]               = useState({ login: '', password: '' });
  const [error, setError]             = useState('');
  const [loading, setLoading]         = useState(false);
  const [companies, setCompanies]     = useState(null);
  const [selectedEmpId, setSelectedEmpId] = useState('');

  const handleChange = (e) => {
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const payload = { login: form.login, password: form.password };
      if (companies && selectedEmpId) payload.empId = parseInt(selectedEmpId);

      const res = await authApi.loginAdmin(payload);

      if (res.data.requireCompanySelection) {
        setCompanies(res.data.companies);
        setSelectedEmpId(res.data.companies[0]?.empId?.toString() || '');
        setLoading(false);
        return;
      }

      loginWithData(res.data.token, res.data.user);
      navigate('/documents');
    } catch (err) {
      setError(err.response?.data?.error || 'Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h5 style={styles.title}>
            <i className="bi bi-shield-lock me-2" style={{ color: COLOR }} />
            Acceso administrador
          </h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={styles.fieldRow}>
            <label style={styles.label}>Usuario:</label>
            <input
              style={styles.input}
              type="text"
              name="login"
              value={form.login}
              onChange={handleChange}
              placeholder="Usuario"
              required
              autoFocus
              autoComplete="username"
            />
          </div>

          <div style={styles.divider} />

          <div style={styles.fieldRow}>
            <label style={styles.label}>Contraseña:</label>
            <input
              style={styles.input}
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Contraseña"
              required
              autoComplete="current-password"
            />
          </div>

          {companies && (
            <div style={styles.fieldRow}>
              <label style={styles.label}>Empresa:</label>
              <CustomSelect
                value={selectedEmpId}
                onChange={e => setSelectedEmpId(e.target.value)}
                style={{ width: '100%' }}
              >
                {companies.map(c => (
                  <option key={c.empId} value={c.empId}>{c.name}</option>
                ))}
              </CustomSelect>
            </div>
          )}

          {error && (
            <div style={{ padding: '0.5rem 1rem', color: '#d32f2f', fontSize: '0.85rem' }}>
              {error}
            </div>
          )}

          <div style={styles.divider} />

          <div style={styles.buttonRow}>
            <button
              type="button"
              className="button"
              onClick={() => { setForm({ login: '', password: '' }); setCompanies(null); setSelectedEmpId(''); }}
              disabled={loading}
            >
              Cancelar
            </button>
            <button type="submit" className="button color1" disabled={loading}>
              {loading ? '…' : 'Ingresar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrapper:    { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f2f5' },
  card:       { backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 12px rgba(0,0,0,0.12)', width: '100%', maxWidth: '400px', overflow: 'hidden', border: '1px solid #e0e0e0' },
  header:     { padding: '0.85rem 1.25rem', borderBottom: '1px solid #e0e0e0' },
  title:      { margin: 0, fontSize: '1rem', fontWeight: '600', color: '#333' },
  fieldRow:   { padding: '0.75rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.35rem' },
  label:      { fontSize: '0.85rem', fontWeight: '500', color: '#444' },
  input:      { padding: '0.5rem 0.75rem', border: '1px solid #ccc', borderRadius: '4px', fontSize: '0.9rem', outline: 'none', width: '100%', boxSizing: 'border-box' },
  divider:    { borderTop: '1px solid #e0e0e0' },
  buttonRow:  { padding: '0.6rem 1rem', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' },
};
